exports = module.exports = require("../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".line-content[data-v-e29beecc] {\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  background-color: #fff;\n  padding: 0 10px;\n  font-size: 12px;\n  line-height: 20px;\n  color: #666;\n}\n.line-content-left[data-v-e29beecc] {\n  left: 10%;\n}\n.line-content-center[data-v-e29beecc] {\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n}\n.line-content-right[data-v-e29beecc] {\n  right: 10%;\n}", ""]);

// exports
